import { Vue, Watch, Component, Prop } from "vue-property-decorator";

@Component({
	components: {},
})
export default class ProductPicture extends Vue {
	@Prop({ default: () => {} })
	value: ItemObject;

	render(h) {
		return (
			<div class="bg-grey-15 width-100 text-white font-size-16 center" style={`line-height:  ${this.value.desc.imageUrl ? "" : "150px"}`}>
				{this.value.desc.imageUrl ? <img src={this.value.desc.imageUrl} class="block width-100" alt="" /> : <el-image src="https://ssl-picture.tenyun.runsasoft.com/tupian.jpeg" />}
			</div>
		);
	}
}
